import { normalizeReferralSiteMarker } from './referralRedirectUrl';

export const REFERRAL_HANDOFF_PARAM = 'handoff';

export function isReferralHandoffLanding(search: string): boolean {
  const value = new URLSearchParams(search).get(REFERRAL_HANDOFF_PARAM);
  return value === '1' || value === 'true';
}

export function clearReferralHandoffFromUrl(): void {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);
  url.searchParams.delete(REFERRAL_HANDOFF_PARAM);
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
}

export function formatOwnerSiteDisplayHost(siteUrl: string): string {
  return normalizeReferralSiteMarker(siteUrl) || siteUrl.trim();
}
